import IOSIdentify from "../../../../contents/docs/libraries/ios/_snippets/identify.mdx";
import IOSSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ios.mdx";
import IdentifiedVsAnonymousIntro from "../../../../contents/docs/product-analytics/_snippets/identified-vs-anonymous-intro.mdx";
import HowToCaptureAnonymousEventsIOS from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-ios.mdx";
import HowToCaptureIdentifiedEventsIOS from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-ios.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import IOSFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-ios.mdx";
import * as React from 'react';
export default {
  IOSIdentify,
  IOSSendEvents,
  IdentifiedVsAnonymousIntro,
  HowToCaptureAnonymousEventsIOS,
  HowToCaptureIdentifiedEventsIOS,
  FeatureFlagsLibsIntro,
  IOSFeatureFlagsCode,
  React
};